import baseAPI from '@/http'

const router = 'api/UnidadeRegional'

export const urAPI = {
  create: (ur) => baseAPI.post(router + '/cadastrar-unidade', ur),
  update: (ur) => baseAPI.put(router + '/atualizar-unidade', ur),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  getByUf: (uf) => baseAPI.get(`${router}/obter-por-uf/${uf}`),
  get: (id) => baseAPI.get(`${router}/${id}`),
  atualizarMunicipios: (filters) => baseAPI.post(`${router}/atualizar-unidades-regionais-municipios`, filters),
  xlsUnidadeRegional: () => baseAPI.get(`${router}/gerar-xlsx-unidade-regional`, { responseType: 'blob' }),

}
